import { ApolloProvider } from '@apollo/client';
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import SnackbarProvider from 'components/Snackbars/SnackbarProvider';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { themes } from 'themes';

import { colors } from 'constants/colors';

import { AnalyticsProvider } from './analytics-context/Provider';
import App from './App';
import './index.css';
import { apolloClient } from './helpers/axios';
import store from './store/store';

const container = document.getElementById('root') as Element;
const root = createRoot(container);

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <ThemeProvider theme={themes}>
      <QueryClientProvider client={queryClient}>
        <ApolloProvider client={apolloClient}>
          <AnalyticsProvider>
            <Provider store={store}>
              <CssBaseline />
              <GlobalStyles styles={{ body: { background: colors.background.main, lineHeight: 'unset' } }} />
              <SnackbarProvider>
                <App />
              </SnackbarProvider>
            </Provider>
          </AnalyticsProvider>
        </ApolloProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
